export const storageFavorites = `${process.env.REACT_APP_STORAGE_NAME}-favorites`;
export const storageCart = `${process.env.REACT_APP_STORAGE_NAME}-cart`;
